export default "//file.bilionpass.com/japandx-portal/0.1.23/static/img/provider-airport.e2fa4048-317e03.svg";